import React, { Component } from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import domain from './domain'
import axios from 'axios'
/**
 *  Home Page Popup Modal
 */

import colors from "./colors";
import ReactHTMLParser from "react-html-parser";
class DownloadModal extends Component {
  constructor(props)
  {
    super(props);
    this.state={
      enableDownload:false
    }
  }
  onSubmit=async(e)=>{
    this.setState({
      enableDownload:true
    })
    e.preventDefault();
    
    

  }
  render() {
    // console.log(this.props)
    return (
      <MDBContainer >
        {/* <MDBBtn color="primary" onClick={this.toggle(14)}>MDBModal</MDBBtn> */}
        <MDBModal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          centered
          backdrop={false}
          size="lg"
      //     style={{
      //   textAlign: "justify",
      //   width: window.innerWidth<1000?"250px":"600px",
      
      //   overflow: "scroll",
      // }}
        >
          <MDBModalHeader
            className="text-center"
            titleClass="w-100 font-weight-bold"
            toggle={this.toggle}
            style={{ background: "#3f51b5", color: "white" }}
          >
            {this.props.title}
          </MDBModalHeader>
          <MDBModalBody
            style={{
              textAlign: "justify",
              height: window.innerHeight>1000?"500px":"300px",
            
              overflow: "scroll",
            }}
          >
            <form onSubmit={this.onSubmit}>

            Purpose
            <div className="input-group">
            
            <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon">
                <i className="fas fa-pencil-alt prefix"></i>
                </span>
              
            </div>
            <textarea className="form-control" id="exampleFormControlTextarea1" rows="5" value={this.state.purpose} required></textarea>
        </div>
        <div className="custom-control custom-checkbox pl-3">
              <input
                className="custom-control-input"
                type="checkbox"
                value=""
                id="invalidCheck"
                required
              />
              <label className="custom-control-label" htmlFor="invalidCheck">
                Agree to terms and conditions
              </label>
              <div className="invalid-feedback">
                You must agree before submitting.
              </div>
            </div>
        <input type="submit"/>
              </form>

           {this.state.enableDownload?<a href={`${domain.Fileserver}/file/Bhuvan_NHP_state_district.zip`} download>Download</a>:null}   
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn
              onClick={this.props.toggle}
              style={{ backgroundColor: "#3f51b5" }}
            >
              Close
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    );
  }
}

export default DownloadModal;
